<template>
    <!-- Search Widget -->
    <div class="card my-4">
        <!-- <h5 class="card-header"><i class="fas fa-search"></i> Procurar</h5>
        <div class="card-body">
            <div class="input-group mb-3">
                <input type="text" class="form-control" placeholder="Procurar por..." aria-label="Procurar por..." aria-describedby="BotaoAddOn">
                <div class="input-group-append">
                    <button class="btn btn-outline-success" type="button">Vai!</button>
                </div>
                </div>
        </div> -->
    </div>
</template>

<script>
    export default {
        mounted() {
        }
    }
</script>
